import React, { useState } from 'react';
import { useCity } from '../contexts/CityContext';
import { useFeed } from '../hooks/useFeed';
import { FeedPost } from '../components/FeedPost';
import { Loading } from '../components/Loading';
import { BottomNav } from '../components/BottomNav';

const FILTERS = [
  { id: 'todos', label: 'Todos' },
  { id: 'promocao', label: 'Promoções' },
  { id: 'evento', label: 'Eventos' },
  { id: 'novidade', label: 'Novidades' },
  { id: 'emprego', label: 'Empregos' },
];

export function FeedPage() {
  const { selectedCity } = useCity();
  const [filter, setFilter] = useState('todos');
  const { posts, loading } = useFeed(selectedCity?.id, filter);

  return (
    <div className="nc-page nc-page--nav">
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(8px)',
        borderBottom: '1px solid var(--nc-border)', padding: '12px 16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <h1 style={{ fontSize: 18, fontWeight: 600, color: 'var(--nc-text)', margin: 0 }}>
            Feed da cidade
          </h1>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.8">
            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9z" />
            <path d="M13.73 21a2 2 0 01-3.46 0" />
          </svg>
        </div>
        <div className="nc-pills" role="group" aria-label="Filtrar feed">
          {FILTERS.map(f => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              className={filter === f.id ? 'nc-pill nc-pill--active' : 'nc-pill'}
              aria-pressed={filter === f.id}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="nc-container" style={{ paddingTop: 12, paddingBottom: 12 }}>
        {loading ? <Loading /> : (
          <>
            {posts.map(post => <FeedPost key={post.id} post={post} />)}
            {posts.length === 0 && (
              <div style={{ textAlign: 'center', padding: 48, color: 'var(--nc-text-secondary)' }}>
                <div style={{ fontSize: 40, marginBottom: 8 }}>📭</div>
                <div style={{ fontSize: 14 }}>Nenhuma publicação ainda</div>
              </div>
            )}
          </>
        )}
      </div>

      <BottomNav />
    </div>
  );
}
